'use client';
import styled from 'styled-components';

export const Container = styled.div`
  width: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding: ${props => props.theme.spacing(3, 0)};

  @media ${({ theme }) => theme.tablet} {
    width: 33%;
    padding: ${({ theme }) => theme.spacing(6)};
  }
`;

export const IconText = styled.p`
  ${({ theme }) => theme.typography.body}
`;

export const ImageContainer = styled.div`
  height: 75px;
  object-fit: contain;
  object-position: center;
  width: 100%;
  margin-bottom: ${({ theme }) => theme.spacing(4)};
  text-align: center;
`;
